export var INTERVALS = ['minutely', 'hourly', 'daily', 'weekly', 'monthly', 'yearly'];